<template>
  <div class="addAdvertiser">
    <head-panel title="广告主管理" subtitle="ADVERTISERS MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit">
        {{currentTitle}}
      </h3>
      <el-form :model="form" ref="form" class="ruleForm" :rules="rules" label-width="12%">
        <el-form-item label="广告主名称" prop="adverName">
          <el-input class="input_sm" v-model="form.adverName" disabled></el-input>
        </el-form-item>
        <el-form-item label="行业类型" prop="industryType">
          <ny-select :data="advertiser.industryMenu" v-model="form.industryType" :keyValue="['value', 'name']"
                     @changeSelectMenu="changeSelect" part="industryType"
                     placeholder="请选择"
                     disabled
                     class="advertiseSelect input_sm">
          </ny-select>
        </el-form-item>
        <el-form-item label="网站URL" prop="url">
          <el-input v-model="form.url" class="input_lg" placeholder="请输入网站URL" disabled></el-input>
          <el-button size="small" type="primary" class="ml16" @click="openUrl">查看网址</el-button>
        </el-form-item>
        <el-form-item label="资质类型" prop="qualificationType">
          <ny-select :data="advertiser.quaTypeMenu" v-model="form.qualificationType" :keyValue="['value', 'name']"
                     @changeSelectMenu="changeSelect" part="quaType"
                     placeholder="请选择"
                     disabled=""
                     class="advertiseSelect input_sm">
          </ny-select>
        </el-form-item>
        <el-form-item label="资质文件">
          <div class="upload-img">
            <img :src="imgUrl" alt="">
          </div>
        </el-form-item>
        <el-form-item label="使用状态" prop="status">
          <ny-select :data="advertiser.statusMenu" v-model="form.status" :keyValue="['value', 'name']"
                     @changeSelectMenu="changeSelect" part="status"
                     placeholder="请选择"
                     class="advertiseSelect input_sm">
          </ny-select>
        </el-form-item>
        <el-form-item class="btnGroups">
          <el-button class="commit" type="primary" @click="submitForm('form')">提交</el-button>
          <el-button class="cancel" type="primary" @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { headPanel, NySelect } from '@/global/components';
import { post, get } from '@/manager/http/index'
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      currentTitle: '审核广告主',
      menuList: [
        {
          name: '航天',
          value: '1'
        },
        {
          name: '媒体',
          value: '2'
        }
      ],
      curMenu: {
        value: ''
      },
      imgUrl: '',
      form: {
        adverName: '',
        industryType: '',
        url: '',
        qualificationType: '',
        fileList1: [],
        status: ''
      },
      rules: {
      }
    };
  },
  mounted () {
    this.init();
  },
  computed: {
    ...mapGetters({
      advertiser: 'advertiser/advertiser',
      userid: 'login/userid'
    })
  },
  methods: {
    init () {
      this.$store.dispatch('advertiser/getStatusMenu')
      this.$store.dispatch('advertiser/getIndustryType')
      this.$store.dispatch('advertiser/getQualificationType')
      this.getAdvertiserInfo()
    },
    getAdvertiserInfo () {
      get('/admin/advertiser/' + this.$route.params.id).then(res => {
        if (res.code === 1) {
          let data = res.data
          this.form.adverName = data.name
          this.form.industryType = data.industry_id + ''
          this.imgUrl = data.qua_file
          this.form.status = data.verify + ''
          this.form.qualificationType = data.qua_type + ''
          this.form.url = data.web_site
        }
      })
    },
    changeSelect ({ select, part }) {
      // console.log(select, part)
    },
    openUrl () {
      window.open(this.form.url)
    },
    submitForm (numberValidateForm) {
      let self = this
      this.$refs[numberValidateForm].validate((valid) => {
        if (valid) {
          let data = {}
          data.verify = self.form.status
          post('/admin/advertiser/verify/' + self.$route.params.id, data).then(res => {
            self.$message('审核成功')
            self.$router.push({ name: 'advertiser' })
          })
        }
      });
    },
    cancel () {
      this.form.pass = '';
      this.form.checkPass = '';
      this.$router.push({ name: 'advertiser' });
    }
  },
  components: {
    headPanel,
    NySelect
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
  .addAdvertiser {
    .ruleForm {
      .input_sm {
        width: 210px;
      }
      .input_lg {
        width: 350px;
      }
      .ml16 {
        margin-left: 16px;
      }
      .mr20 {
        margin-right: 20px;
      }
      .el-form-item{
        margin-bottom:22px;
      }
      .upload-img{
        width:200px;
        height:200px;
        display: inline-block;
        img{
          width: 100%;
          height:100%;
          display: block;
        }
      }
      .btnGroups{
        text-align: left;
        margin-left:16px;
      }
    }
  }
</style>
